import React, {Fragment} from "react";

const Box = (props) => {
    return <Fragment>
        <div className="bg-white p-6 rounded-2xl shadow-sm ring-1 ring-gray-950/5 my-4">
            {
                props.title && <h1 className="text-lg font-semibold leading-tight text-gray-900 pb-4 mb-4 border-b border-gray-100">
                    {props.title}
                </h1>
            }
            {props.children}
        </div>
    </Fragment>
}

export default Box;
